function normalizeManufacturers(manufacturerList) {
  let normalizedManufacturers = [];

  for (let i = 0; i < manufacturerList.length; i++) {
    let obj = manufacturerList[i];

    let node = {
      id: obj.manufacturerId,
      label: obj.name,
    };

    // manufacturer list normalized for vuelist presentation
    normalizedManufacturers.push(node);
  }

  return normalizedManufacturers;
}

function filterOut(manufacturers, manufacturerFacets) {
  // should filter out only those manufacturers from the list that are present among products
  // (this is done through facets)
  let filteredManufacturers = [];

  for (let i = 0; i < manufacturerFacets.length; i++) {
    for (let j = 0; j < manufacturers.length; j++) {
      if (manufacturers[j].id === manufacturerFacets[i].value) {
        filteredManufacturers.push(manufacturers[j]);
      }
    }
  }

  return filteredManufacturers;
}

export { normalizeManufacturers, filterOut };
